// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"455dae9e","455":"c3cd7a99"}[chunkId] + ".chunk.js";
};